import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.2, 0.7, 0.2, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

// Line-by-line masked text reveal (splits by \n)
export const LineReveal = ({ lines, delay = 0, className = "", lineClassName = "" }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * 0.12, ease: [0.2, 0.7, 0.2, 1] }}
          className={lineClassName}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

// Image reveal — masked scale + slight parallax
export const ImageReveal = ({ src, alt, className = "", imgClassName = "" }) => (
  <div className={`overflow-hidden ${className}`}>
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      initial={{ scale: 1.2, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.4, ease: [0.2, 0.7, 0.2, 1] }}
      className={`w-full h-full object-cover ${imgClassName}`}
    />
  </div>
);
